import React, { Component } from "react";
import { ResponsiveContainer, BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Bar, Cell } from 'recharts';
import { Panel } from "react-bootstrap";
import { invokeApig } from '../../libs/awsLib';

export default class AlertsChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      data: []
    };
  }

  componentDidMount = async () => {
  	this.setState({ isLoading: true, data: [] });

	this.alerts().then((response) => {
		this.setState({ data: response, isLoading: false });
	}, (error) => {
		alert(error);
		this.setState({ isLoading: false });
	});
  }
  alerts() {
      return invokeApig({
          path: "/summary/alerts",
          method: "POST",
          body: {}
      });
  }

  renderChart() {
	  let style = {
        width: 600,
        height: 370
      };
	  const data = this.state.data;
	  const COLORS = ['#ff0000', '#0000ff', '#3cb371', '#ee82ee', '#ffa500', '#6a5acd', '#5dade2'];
	  return (
	    <div className="item" style={style}>
	    <ResponsiveContainer>
	      <BarChart width={600} height={320} data={data}
		          margin={{top: 5, right: 30, left: 20, bottom: 5}}>
		     <CartesianGrid strokeDasharray="3 3"/>
		     <XAxis dataKey="name"/>
		     <YAxis/>
		     <Tooltip/>
		     <Bar dataKey="count" fill={'#F9df34'} label={{ position: 'top' }}>
		       {
	             data.map((entry, index) => <Cell key={index} fill={COLORS[index % COLORS.length]}/>)
	           }
		     </Bar>
		  </BarChart>
	    </ResponsiveContainer>
	    </div>
	  );
  }
  render() {
    return (
	  <center>
	    <Panel className="Chart">
          <Panel.Heading>Alertas</Panel.Heading>
          <Panel.Body>
        	{this.renderChart()}
          </Panel.Body>
        </Panel> 
	  </center>
    );
  }
  
}



// WEBPACK FOOTER //
// ./src/containers/summary/AlertsChart.js